import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { GraphCSVProps } from "../../../wrappers/LoadingGraph";

export const headers = [
  {
    label: "Year",
    key: "year",
  },
  {
    label: "Week",
    key: "week",
  },
  {
    label: "Count",
    key: "count",
  },
];

const YoyAdsCSV = ({ data }: GraphCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default YoyAdsCSV;
